import React from 'react';
import { Form } from 'antd';
import { has, path, pathOr } from 'ramda';
import cx from 'classnames';

export default WrappedComponent => ({ label, ...props }) => {
    const { form = {}, field = {} } = props;
    const isTouched = path(['status', 'isSubmitStarted'], form);
    const error = path(['errors', field.name], form);
    const showError = error && isTouched ? 'error' : '';
    const fieldBuildedSchema = pathOr({}, ['status', 'validationSchema', field.name, '_exclusive'], form);
    const hasRequiredMsg = error === 'Это обязательное поле' || error === 'Загрузите документ';
    const required = has('required', fieldBuildedSchema) || hasRequiredMsg;

    return (
        <div className={cx({ required })}>
            <Form.Item
                label={label}
                help={showError && error}
                validateStatus={showError}
            >
                <WrappedComponent {...props} />
            </Form.Item>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/hocs/withFormItem.js